import { render, staticRenderFns } from "./c-radio-group.vue?vue&type=template&id=1ac1270a&scoped=true&"
import script from "./c-radio-group.vue?vue&type=script&lang=js&"
export * from "./c-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./c-radio-group.vue?vue&type=style&index=0&id=1ac1270a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1270a",
  null
  
)

export default component.exports